// src/views/apps/prospects/store/reducer/index.js

// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1, // páginas totales
  params: {
    page: 1,
    perPage: 20,
    sortBy: 'id',
    sortOrder: 'asc',
    q: ''
  },
  selectedUser: null,
  isps: [],
  plans: [],
  cities: [],
};

const prospectos = (state = initialState, action) => {
  switch (action.type) {
    case 'PROSPECTS_SET_QUERY':
      // Guardar la query y resetear a la página 1
      return {
        ...state,
        params: { ...state.params, q: action.q, page: 1 }
      };

    case 'GET_ALL_DATA_USER':
      return {
        ...state,
        allData: action.data,
        selectedUser: null,
        total: action.totalPages,
        // 🔑 merge para no perder q/sort/paginación previos
        params: { ...state.params, ...(action.params || {}) },
      };

    case 'GET_DATA':
      return {
        ...state,
        allData: action.data,
        selectedUser: null,
        total: action.totalPages,
        params: { ...state.params, ...(action.params || {}) },
      };

    case 'GET_DATA_USER':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: { ...state.params, ...(action.params || {}) },
      };

    case 'GET_USER':
      return { ...state, selectedUser: action.selectedUser };

    case 'ADD_USER':
      return { ...state };

    case 'DELETE_USER':
      return { ...state };

    case 'INITIATE_INSTANCE':
      return { ...state };

    case 'GET_ALL_DATA_ISP_X':
      return { ...state, isps: action.data };

    case 'GET_ALL_DATA_PLAN':
      return { ...state, plans: action.data };

    case 'GET_ALL_DATA_CITY':
      return { ...state, cities: action.data };

    case 'SEARCH_USERS':
      console.log('kkkk');
      return {
        ...state,
        allData: action.data,
        total: action.totalPages,
        params: { ...state.params, ...(action.params || {}) },
      };

    default:
      return state;
  }
};

export default prospectos;
